// Two short tones when the Director's mic opens (rising) and closes (falling), so you know without looking.
// Same tones as the personal studio (packages/studio/src/web/beep.ts).
let ctx: AudioContext | null = null;

/** Create / resume the context inside a tap (Safari only starts audio from a user gesture). */
export function primeBeeps() {
  try {
    if (!ctx) {
      const AC = window.AudioContext ?? (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
      ctx = new AC();
    }
    if (ctx.state !== "running") void ctx.resume().catch(() => undefined);
  } catch {
    ctx = null;
  }
}

export function beep(kind: "on" | "off") {
  primeBeeps();
  if (!ctx) return;
  const c = ctx;
  const notes = kind === "on" ? [660, 990] : [880, 523];
  const t0 = c.currentTime + 0.02;
  notes.forEach((f, i) => {
    const osc = c.createOscillator();
    const g = c.createGain();
    osc.type = "sine";
    osc.frequency.value = f;
    const s = t0 + i * 0.11;
    g.gain.setValueAtTime(0, s);
    g.gain.linearRampToValueAtTime(0.22, s + 0.012);
    g.gain.exponentialRampToValueAtTime(0.0008, s + 0.1);
    osc.connect(g).connect(c.destination);
    osc.start(s);
    osc.stop(s + 0.11);
  });
}

// keep the screen on while the mic is open (phone in one hand)
let lock: { release(): Promise<void> } | null = null;
export async function keepAwake(on: boolean) {
  try {
    const wl = (navigator as unknown as { wakeLock?: { request(t: "screen"): Promise<{ release(): Promise<void> }> } }).wakeLock;
    if (on && wl && !lock) lock = await wl.request("screen");
    if (!on && lock) {
      await lock.release();
      lock = null;
    }
  } catch {
    lock = null;
  }
}
